export function path_join(...parts: string[]) {
  const cleaned = parts.map(p => p.trim().replace(/^\/+|\/+$/g, '')).filter(Boolean);
  return '/' + cleaned.join('/');
}
